import logger from 'helpers/logger';
import { capitalizeFirstLetter } from 'helpers/string';
import { PageContentResponse } from 'application/repositories/pageContentRepository';
import dynamic from 'next/dynamic';

const pageTypes = {
	HomePageFeature: dynamic(() => import('features/PageTypes/HomePage').then((mod) => ({ default: mod.HomePageFeature }))),
	ArticlePageFeature: dynamic(() => import('features/PageTypes/ArticlePage').then((mod) => ({ default: mod.ArticlePageFeature }))),
	ContentPageFeature: dynamic(() => import('features/PageTypes/ContentPage').then((mod) => ({ default: mod.ContentPageFeature }))),
	NewsPageFeature: dynamic(() => import('features/PageTypes/NewsPage').then((mod) => ({ default: mod.NewsPageFeature }))),
	EquipmentPageFeature: dynamic(() => import('features/PageTypes/EquipmentPage').then((mod) => ({ default: mod.EquipmentPageFeature }))),
};

export const PageTypeMapFeature: React.FC<PageContentResponse['page']> = ({ template, accessToken, culture, ...page }) => {
	const production = process.env.NODE_ENV === 'production';

	// Quick fix for an error from BEs data migration
	// TODO: fix this so that we can come back to standard: `${capitalizeFirstLetter(template)}PageFeature`
	const featureName = template.includes('Page') ? `${capitalizeFirstLetter(template)}Feature` : `${capitalizeFirstLetter(template)}PageFeature`;

	const DynamicPageTemplate = pageTypes[featureName];

	const message = `PageType [${template}] is missing a React Component. Add missing export '${featureName}' from /features`;

	if (!DynamicPageTemplate && !production) {
		return <div>{message}</div>;
	}

	if (!DynamicPageTemplate && production) {
		logger.error(message);
		return null;
	}

	return <DynamicPageTemplate {...page} accessToken={accessToken} culture={culture} />;
};
